import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Search } from "lucide-react";

const CATEGORY_IMAGES = {
  Tech: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=1200",
  Home: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200",
  Fashion: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200",
  Beauty: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=1200",
  Sports: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=1200",
  Gym: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200",
};

const FALLBACK_IMG = "https://images.unsplash.com/photo-1607082350899-7e105aa886ae?w=800";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories")
      .then((r) => setCategories(r.data || []))
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = q.trim()
    ? categories.filter((c) => c.name.toLowerCase().includes(q.trim().toLowerCase()))
    : categories;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#0033FF] font-bold mb-2">All categories</div>
          <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tight">Browse the marketplace</h1>
          <p className="mt-3 text-sm text-neutral-600">
            {loading ? "Loading…" : `${categories.length} ${categories.length === 1 ? "category" : "categories"} to explore.`}
          </p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
          <input
            data-testid="categories-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search categories…"
            className="w-full h-11 pl-10 pr-3 border border-black rounded-none text-sm"
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="border border-neutral-200 p-12 text-center text-neutral-500" data-testid="categories-empty">
          {loading ? "Loading…" : q.trim() ? `No category matches "${q}".` : "No categories yet."}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 border-t border-l border-neutral-200">
          {filtered.map((c) => (
            <Link
              key={c.category_id}
              to={`/products?category=${encodeURIComponent(c.name)}`}
              data-testid={`all-category-${c.slug}`}
              className="group relative aspect-square border-b border-r border-neutral-200 overflow-hidden"
            >
              <img
                src={c.image_url || CATEGORY_IMAGES[c.name] || FALLBACK_IMG}
                alt={c.name}
                className="absolute inset-0 w-full h-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors" />
              <div className="absolute bottom-4 left-4 right-4 text-white font-display font-black text-xl sm:text-2xl">
                {c.name}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
